import { useAppContext } from "@web/route-services/root/AppContext";
import { AuthModal } from "./AuthModal";

export function AuthButtons() {
  const { createModal } = useAppContext();
  const clickHandler = (formType: "signup" | "signin") => async () => {
    createModal({
      content: <AuthModal formKind={formType} />,
      // Prevent close on click outside
      onInteractOutside: (e) => {
        e.preventDefault();
      }
    });
  };

  return (
    <div className="mt-1 flex items-center justify-center space-x-5">
      <button
        className="flex items-center space-x-2 whitespace-nowrap rounded-lg px-2 py-2 font-medium transition duration-200 ease-out "
        onClick={clickHandler("signup")}
      >
        Sign Up
      </button>
      <button
        className="border-line bg-button-primary hover:bg-button-primary-hover flex items-center space-x-2 whitespace-nowrap rounded-lg border px-4 py-2 font-medium transition duration-200 ease-out"
        onClick={clickHandler("signin")}
      >
        Login
      </button>
    </div>
  );
}
